import { defaultMapStyle } from '@/components/map/MapStyles'
import { Coordinate } from 'ol/coordinate'
import { LayerConfig } from './LayerConfig'
export class MapUiState {
  public typeUiid: string
  public layermapVisibility: any
  public layermapOpacity: { [index: number]: number }
  public layermapconfig: { [index: number]: LayerConfig }
  public refresh: boolean
  public defaultMapStyles: any
  public mapCenter: Coordinate
  public mapZoom: number
  public refreshBestFit: boolean
  public bestFitMisId: number
  public refreshMap: boolean
  public showHeading: boolean
  public showOceanCurrent: boolean
  public showCycle: boolean
  public showAis: boolean
  public aisStartDateUtc: string | null
  public aisEndDateUtc: string | null
  public showWaypoint: boolean
  public showDrift: boolean
  public showPath: boolean
  public showMissionPlan: boolean
  public showMissionPlanValidation: boolean
  public showMissionLayer: boolean
  public showEndMissionSimulation: boolean
  public endMissionSimulationMapOpacity: number
  public showGraticule: boolean
  public missionLayermapOpacity: number
  public baseMapLayer: any
  public currentMin: number
  public currentMax: number
  public currentZoom: number

  constructor({
    typeUiid = 'detail', //detail ou global ou fleet ou picker ou simulation
    layermapVisibility = {},
    layermapOpacity = {},
    layermapconfig = {} as { [index: number]: LayerConfig },
    refresh = false,
    defaultMapStyles = defaultMapStyle,
    mapCenter = [0, 0] as Coordinate,
    mapZoom = 2,
    refreshBestFit = true,
    bestFitMisId = -1,
    refreshMap = true,
    showHeading = false,
    showOceanCurrent = false,
    showCycle = false,
    showAis = false,
    aisStartDateUtc = null,
    aisEndDateUtc = null,
    showWaypoint = true,
    showDrift = false,
    showPath = true,
    showMissionPlan = false,
    showMissionPlanValidation = false,
    showMissionLayer = true,
    showEndMissionSimulation = false,
    showGraticule = false,
    endMissionSimulationMapOpacity = 100,
    missionLayermapOpacity = 100,
    baseMapLayer = { id: 'OSM' },
    currentMin = 0.01,
    currentMax = 0.25,
    currentZoom = 1,
  } = {}) {
    this.typeUiid = typeUiid
    this.layermapVisibility = layermapVisibility
    this.layermapOpacity = layermapOpacity
    this.layermapconfig = layermapconfig
    this.refresh = refresh
    this.defaultMapStyles = defaultMapStyles
    this.mapCenter = mapCenter
    this.mapZoom = mapZoom
    this.refreshBestFit = refreshBestFit
    this.bestFitMisId = bestFitMisId
    this.refreshMap = refreshMap
    this.showHeading = showHeading
    this.showOceanCurrent = showOceanCurrent
    this.showCycle = showCycle
    this.showAis = showAis
    this.aisStartDateUtc = aisStartDateUtc
    this.aisEndDateUtc = aisEndDateUtc
    this.showWaypoint = showWaypoint
    this.showDrift = showDrift
    this.showPath = showPath
    this.showMissionPlan = showMissionPlan
    this.showMissionPlanValidation = showMissionPlanValidation
    this.showMissionLayer = showMissionLayer
    this.showEndMissionSimulation = showEndMissionSimulation
    this.showGraticule = showGraticule
    this.missionLayermapOpacity = missionLayermapOpacity
    this.endMissionSimulationMapOpacity = endMissionSimulationMapOpacity
    this.baseMapLayer = baseMapLayer
    this.currentMin = currentMin
    this.currentMax = currentMax
    this.currentZoom = currentZoom
  }
}
